// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_rz-0";
export var checkoutRateBadgeLink = "_rz-1";